///---------------------------------------------------------------------------
//! Copyright (C) ASQUARED SRL - All Rights Reserved
//* Unauthorized copying of this file, via any medium is strictly prohibited
//* Proprietary and confidential
//* Written by Alexandru Gârbacea <g99.alex@yahoo.com>, September 2022
//? @author g99.alex@yahoo.com
///---------------------------------------------------------------------------

import { createPortal } from 'react-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'

const ConfirmBox = ({
onConfirm,
onClose,
content,
title,
buttonConfirm = 'Confirmă',
buttonCancel = 'Anulează'
}) => {
    const OUTSIDE_ID = 'modal-confirm-wrapper-bg'

    const handleOutsideClick = (id) => {
        if(id === OUTSIDE_ID) onClose()
    }

    //? Rendered into <body> so an animated or transformed ancestor can never capture this
    //? position:fixed overlay and centre it on a card instead of the viewport
    return createPortal(
        <div className='md-overlay' id={OUTSIDE_ID} onClick={(e) => handleOutsideClick(e.target.id)}>
            <div className='md-modal md-modal--sm'>
                <div className='md-header'>
                    <h2 className='md-header__title'>{title}</h2>
                    <button className='md-header__close' onClick={() => onClose()}>
                        <FontAwesomeIcon icon={faXmark} />
                    </button>
                </div>
                <div className='md-body'>
                    <div className='md-confirm__text'>
                        {content}
                    </div>
                </div>
                <div className='md-footer md-footer--center'>
                    <button className='md-btn md-btn--ghost' onClick={() => onClose()}>
                        {buttonCancel}
                    </button>
                    <button className='md-btn md-btn--primary' onClick={() => onConfirm()}>
                        {buttonConfirm}
                    </button>
                </div>
            </div>
        </div>,
        document.body
    )
}

export default ConfirmBox
